import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { BroadbandComponent } from './home/broadband/broadband.component';
import { FiberComponent } from './home/fiber/fiber.component';
import { AdminComponent } from './admin/admin.component';
import { AdminbackendComponent } from './admin/adminbackend/adminbackend.component';
import { CreateplanComponent } from './admin/adminbackend/createplan/createplan.component';
import { EditplanComponent } from './admin/adminbackend/editplan/editplan.component';
import { AllplansComponent } from './admin/adminbackend/allplans/allplans.component';
import { ManageusersComponent } from './admin/adminbackend/manageusers/manageusers.component';
import { ManageordersComponent } from './admin/adminbackend/manageorders/manageorders.component';
import { PlansComponent } from './plans/plans.component';
import { SigninComponent } from './user/signin/signin.component';
import { AuthGuard } from './guards/auth.guard';
import { SignupComponent } from './user/signup/signup.component';
import { PwresetComponent } from './user/pwreset/pwreset.component';
import { VerifyemailComponent } from './user/verifyemail/verifyemail.component';
import { InnerpagesGuard } from './guards/innerpages.guard';
import { AboutComponent } from './home/about/about.component';
import { ContactComponent } from './about/contact/contact.component';
import { FeedbackComponent } from './about/feedback/feedback.component';
import { OurServicesComponent } from './about/our-services/our-services.component';
import { SelectedplanComponent } from './home/selectedplan/selectedplan.component';
import { OrdersComponent } from './home/orders/orders.component';
import { TermsnconditionsComponent } from './termsnconditions/termsnconditions.component';
import { AdminGuard } from './guards/admin.guard';
import { PpolicyComponent } from './termsnconditions/ppolicy/ppolicy.component';
import { UpolicyComponent } from './termsnconditions/upolicy/upolicy.component';
import { MessagesComponent } from './admin/adminbackend/messages/messages.component';



const routes: Routes = [
  { path: 'signin', component: SigninComponent, canActivate:[AuthGuard]},
  { path: 'signup', component: SignupComponent, canActivate:[AuthGuard]},
  { path: 'pwreset', component: PwresetComponent, canActivate:[AuthGuard]},
  { path: 'verifyemail', component: VerifyemailComponent, canActivate:[AuthGuard]},
  
  { path: '', component: HomeComponent },
  { path: 'termsnconditions', component: TermsnconditionsComponent},
  { path: 'ppolicy', component: PpolicyComponent},
  { path: 'upolicy', component: UpolicyComponent},
  { path: 'selected', component: SelectedplanComponent, canActivate:[InnerpagesGuard]},
  { path: 'orders', component: OrdersComponent, canActivate:[InnerpagesGuard]},
  { path: 'about', component: AboutComponent},
  { path: 'services', component: OurServicesComponent},
  { path: 'contact', component: ContactComponent},
  { path: 'feedback', component: FeedbackComponent},
  { path: 'bplans', component: BroadbandComponent},
  { path: 'fplans', component: FiberComponent},
  { path: 'adminpanel', component: AdminComponent },
  { path: 'adminbackend', component: AdminbackendComponent, canActivate:[AdminGuard],
    children: [
      { path: 'createplan', component: CreateplanComponent},
      { path: 'editplan/:plan', component: EditplanComponent},
      { path: 'allplans', component: AllplansComponent},
      { path: 'manageusers', component: ManageusersComponent},
      { path: 'manageorders', component: ManageordersComponent},
      { path: 'messages', component: MessagesComponent}
    ] },
  { path: 'plans', component: PlansComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
